import { gql, TypedDocumentNode } from "@apollo/client";

import { GithubEnterpriseIntegration, QueryGithubEnterpriseIntegrationArgs } from "types/generated";

export type GitHubEnterpriseIntegrationData = Pick<
  GithubEnterpriseIntegration,
  | "id"
  | "name"
  | "description"
  | "apiHost"
  | "appID"
  | "appUrl"
  | "githubAppStatus"
  | "isDefault"
  | "labels"
  | "space"
  | "useGitCheckout"
  | "userFacingHost"
  | "vcsChecks"
  | "webhookSecret"
  | "webhookUrl"
>;

type GetGitHubEnterpriseIntegrationResponse = {
  githubEnterpriseIntegration: GitHubEnterpriseIntegrationData;
};

export const GET_GITHUB_ENTERPRISE_INTEGRATION: TypedDocumentNode<
  GetGitHubEnterpriseIntegrationResponse,
  QueryGithubEnterpriseIntegrationArgs
> = gql`
  query GetGitHubEnterpriseIntegration($id: ID!) {
    githubEnterpriseIntegration(id: $id) {
      vcsChecks
      useGitCheckout
      apiHost
      appID
      appUrl
      description
      githubAppStatus
      id
      labels
      name
      isDefault
      space {
        id
        name
        accessLevel
      }
      userFacingHost
      webhookSecret
      webhookUrl
    }
  }
`;
